import React from "react";
import style from "../QuestionResponses.module.css";
export const FORM_NOT_ATTEMPTED_YET_LABEL = (
  <div className={style.formNotAttempedYet}>Form not attempted yet</div>
);
